import React from "react";
import L from "leaflet";
import "leaflet-geotiff-2";
import "leaflet-geotiff-2/dist/leaflet-geotiff-plotty";
import { withLeaflet, MapLayer } from "react-leaflet";
import { cloneDeep } from "lodash";
import { results as resultsColors } from "../../../common/VisualizationPresets/colorPalettes";
import * as plotty from "leaflet-geotiff-2/node_modules/plotty";

const PLOTTY_COLORSCALE_POSITIONS = [
  0, 0.125, 0.25, 0.375, 0.5, 0.625, 0.75, 0.875, 1,
];

function ensurePlottyColorScale(colorName) {
  if (!colorName || Object.hasOwn(plotty.colorscales, colorName)) {
    return;
  }
  const palette = resultsColors[colorName];
  if (palette) {
    plotty.addColorScale(colorName, palette, PLOTTY_COLORSCALE_POSITIONS);
    return;
  }
  if (
    typeof colorName === "string" &&
    colorName.startsWith("inv") &&
    resultsColors[colorName.slice(3)]
  ) {
    const invPalette = cloneDeep(resultsColors[colorName.slice(3)]).reverse();
    plotty.addColorScale(colorName, invPalette, PLOTTY_COLORSCALE_POSITIONS);
  }
}

export const ExtraGeotiffLayer = withLeaflet((props) => {
  return <PlottyGeotiffLayer ref={props.onResultsReady} {...props} />;
});

export class PlottyGeotiffLayer extends MapLayer {
  createLeafletElement(props) {
    const {
      topographyUrl,
      displayMin,
      displayMax,
      colorName,
      zIndex,
      opacity,
    } = props;

    ensurePlottyColorScale(colorName);

    let plottyRenderer = L.LeafletGeotiff.plotty({
      displayMin: displayMin,
      displayMax: displayMax,
      colorScale: colorName,
      opacity: opacity,
    });

    let leafletGeotiff = new L.leafletGeotiff(topographyUrl, {
      renderer: plottyRenderer,
      noDataValue: undefined,
      noDataKey: undefined,
      blockSize: 65536,
      opacity: opacity,
    });

    if (zIndex !== undefined) {
      leafletGeotiff.setZIndex(zIndex);
    }
    return leafletGeotiff;
  }

  componentDidMount() {
    const { map } = this.props.leaflet;
    this.leafletElement.addTo(map);
  }
}
